// CSS
import './CreateAccount.css';
// React hooks
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// External hooks/components
import { SignUp, useAuth as useClerkAuth } from '@clerk/react';
// Media assets
import CloseIcon from '../../assets/StandardIcons/close-icon-black.svg';


// =============
// CreateAccount – represents the /create-account page
// =============
function CreateAccount(){

    // destructure GC
    const { isSignedIn } = useClerkAuth();

    // initialize react hooks
    const navigate = useNavigate();
    const location = useLocation();

    // Edge case: Automatically re-direct ALL already signed-in @Clerk Users.
    useEffect(() => {

        // send back to home page
        if (isSignedIn) { navigate('../'); };
    
    }, [isSignedIn]);

    // ========================
    // handleCloseButtonClick()
    // ========================
    const handleCloseButtonClick = () => {

        navigate(location.state?.from || '/');
    };

    
    // JSX Component
    return(
        <div className='CreateAccount'>
            
            {/* Aesthetic background */}
            <div className='create-account-aesthetic-bg'></div>

            {/* Close button */}
            <img src={ CloseIcon } className='create-account-close-button' onClick={ () => handleCloseButtonClick() } alt='Click to return to the previous page'/>

            {/* Main (form) content */}
            <div className='CreateAccount-form-content'>
                
                {/* @clerk SignUp Form */}
                <SignUp
                    path="/create-account"
                    routing="path"
                    signInUrl="/login"
                />

            </div>
        </div>
    );
}



// Export statement
export default CreateAccount;